import React, { useState } from 'react';
import ReactSVG from 'react-svg';
import { useControlSessions } from '~/hooks';
import { useTranslation } from '~/dependencies';
import AgentsList, { Agent, AgentActionsProps } from '~/components/AgentsList';
import { isValidInviteTarget } from '~/helpers';
import { IconTransfer } from '~/assets/svgIcons';
import { Container, SearchNumber, ActionsContainer } from './styles';

type Props = {
  sessionId: string;
};

/**
 * Manage the numerTo and perform a blind transfer or attended transfer
 * @param {String} sessionId - A unformatted sessionId contains special characters symbols
 */
const TransferTo = ({ sessionId }: Props) => {
  const { t } = useTranslation();

  const [numberTo, setNumberTo] = useState<string>('');

  function onTransferNumberChange(number: string) {
    setNumberTo(number);
  }

  return (
    <Container>
      <SearchNumber qty={numberTo ? numberTo.length : 0}>
        <input
          value={numberTo}
          placeholder={t('components.activeCalls.transferTo.transferTo')}
          onChange={event => onTransferNumberChange(event.target.value)}
        />

        {isValidInviteTarget(numberTo) && (
          <ActionsContainer>
            <TransferActions sessionId={sessionId} numberTo={numberTo} />
          </ActionsContainer>
        )}
      </SearchNumber>

      <AgentsList maxHeight="435" agentNameMaxLength={8} searchFor={numberTo}>
        {(agentActionsProps: AgentActionsProps) => (
          <ActionsContainer>
            <TransferActions {...agentActionsProps} sessionId={sessionId} />
          </ActionsContainer>
        )}
      </AgentsList>
    </Container>
  );
};

export default TransferTo;

type TransferActionsProps = {
  sessionId: string;
  numberTo?: string;
  agent?: Agent;
};

const TransferActions = ({
  agent,
  sessionId,
  numberTo,
}: TransferActionsProps) => {
  const { t } = useTranslation();
  const controlSessions = useControlSessions();

  const phoneNumber = String(agent?.number || numberTo).replace(/\s+/g, '');

  function blindTransfer() {
    controlSessions(sessionId, 'transferOff');
    controlSessions(sessionId, 'blindtransfer', phoneNumber);
  }

  function attendedTransfer() {
    controlSessions(sessionId, 'transferOff');
    controlSessions(sessionId, 'waitingTransfer', phoneNumber);
    controlSessions(sessionId, 'invite', phoneNumber);
  }

  return (
    <ActionsContainer>
      <button type="button" onClick={() => blindTransfer()}>
        <ReactSVG src={IconTransfer} className="icon-start-transfer" />
        <span>{t('components.activeCalls.transferTo.transfer')}</span>
      </button>
      <button type="button" onClick={() => attendedTransfer()}>
        <ReactSVG src={IconTransfer} className="icon-start-transfer" />
        <span>{t('components.activeCalls.transferTo.callFirst')}</span>
      </button>
    </ActionsContainer>
  );
};

TransferActions.defaultProps = {
  numberTo: null,
  agent: null,
};
